<script lang="ts">
    import { openModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';

    import ModalSelectLocation from '../Modals/ModalSelectLocation.svelte';
    import { Location } from './Location';

    export let location: Location;
    export let title: string = 'Wybierz punkt...';
    export let styleMode: 'filter' | 'link' | 'standard' = 'filter';
    export let disabled: boolean = false;

    export let onSelect: (location: Location) => void;
</script>

<div class="select-location-container">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
        class="dont-break select-vehicle select-vehicle-{styleMode} {disabled ? 'disabled' : ''}"
        on:click={() => {
            console.log('click');
            openModal(ModalSelectLocation, {
                alreadyUsedItems: [],
                onClick: selectedLocation => {
                    console.log('Selected item', selectedLocation);
                    location = selectedLocation;
                    onSelect(selectedLocation);
                },
            });
        }}
    >
        {#if location.getExtId()}
            <span class="bold">{location.getExtId()}</span>
            {location.getCity()}, {location.getStreet()}
        {:else}
            {$_(title)}
        {/if}
    </div>
</div>

<style>
    .select-location-container {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .select-vehicle {
        position: relative;
        cursor: pointer;
        display: flex;
        align-items: center;
        column-gap: 5px;
        font-size: inherit;
        justify-content: flex-start;
        padding: 0 0 0 5px;
        overflow: hidden;
    }
    .select-vehicle-filter {
        width: 300px;
    }
    .select-vehicle-standard {
        width: 300px;
    }
    .select-vehicle-link:hover {
        color: var(--automapa-blue);
        text-decoration: underline;
    }
    .disabled {
        /*cursor: not-allowed;*/
        color: #b0b0b0;
        /* block events */
        pointer-events: none;
    }
</style>
